import { IHttpService } from "../HttpService";
import Notice, { INotice } from "../../model/notice/Notice";

export interface INoticeService {
  getNoticeList(languageCode: string): Promise<INotice[]>;
}

const NoticeService = (httpService): INoticeService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api/notices";
  const _lanugagePath: string = "/language";
  const _noticePath: string = "/notice";

  const NoticeListMapper = (json = []) => {
    return json.map((item: any) => Notice(item));
  };

  return {
    async getNoticeList(languageCode: string) {
      const path = _http.buildPath(
        _basePath,
        _lanugagePath,
        languageCode,
        _noticePath
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return NoticeListMapper(responseJSON);
    }
  };
};

export default NoticeService;
